module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_jordan_05.fe41b21a.jpg";